const user = '/icon/user.png'

const imgErr = ev => {
  ev.target.src = user
}

export default imgErr
